/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {AnimationPlayer, AnimationTriggerMetadata} from '@angular/animations';
/**
 * @abstract
 */
export abstract class AnimationEngine {
/**
 * @abstract
 * @param {?} trigger
 * @param {?=} name
 * @return {?}
 */
registerTrigger(trigger: AnimationTriggerMetadata, name?: string) {}
/**
 * @abstract
 * @param {?} element
 * @param {?} domFn
 * @return {?}
 */
onInsert(element: any, domFn: () => any) {}
/**
 * @abstract
 * @param {?} element
 * @param {?} domFn
 * @return {?}
 */
onRemove(element: any, domFn: () => any) {}
/**
 * @abstract
 * @param {?} element
 * @param {?} property
 * @param {?} value
 * @return {?}
 */
setProperty(element: any, property: string, value: any) {}
/**
 * @abstract
 * @param {?} element
 * @param {?} eventName
 * @param {?} eventPhase
 * @param {?} callback
 * @return {?}
 */
listen(
      element: any, eventName: string, eventPhase: string,
      callback: (event: any) => any) {}
/**
 * @abstract
 * @return {?}
 */
flush() {}
/**
 * @return {?}
 */
get activePlayers(): AnimationPlayer[] { throw new Error('...'); }
/**
 * @return {?}
 */
get queuedPlayers(): AnimationPlayer[] { throw new Error('...'); }
}
